import React from 'react';
import PropTypes from 'prop-types';
import {
  Icon,
  Popup,
} from 'semantic-ui-react';

const InstagramAccountType = ({ instagram, isProfessional, isBusiness, isRestricted, isPrivate, restrictedText }) => {
  if (!instagram) {
    return (<span>-</span>);
  }

  if (isRestricted) {
    return (
      <Popup
        trigger={<Icon name="ban" color="orange" />}
        content={`Instagram RESTRICTED account: ${restrictedText}`}
      />
    );
  }

  if (isProfessional) {
    return (
      <Popup
        trigger={<Icon name="briefcase" color="pink" />}
        content={'Instagram CREATOR account'}
      />
    );
  }

  if (isBusiness) {
    return (
      <Popup
        trigger={<Icon name="briefcase" color="blue" />}
        content={'Instagram BUSINESS account'}
      />
    );
  }

  if (isPrivate) {
    return (
      <Popup
        trigger={<Icon name="lock" color="orange" />}
        content={'Instagram PRIVATE account'}
      />
    );
  }

  return (
    <Popup
      trigger={<Icon name="user circle" color="grey" />}
      content={'Instagram PERSONAL account'}
    />
  );
};

InstagramAccountType.propTypes = {
  instagram: PropTypes.object.isRequired,
  isProfessional: PropTypes.bool.isRequired,
  isBusiness: PropTypes.bool.isRequired,
  isRestricted: PropTypes.bool.isRequired,
  isPrivate: PropTypes.bool.isRequired,
  restrictedText: PropTypes.string.isRequired,
};


export default InstagramAccountType;



/** WEBPACK FOOTER **
 ** ./src/components/instagram-account-type/index.js
 **/